import { useMemo } from "react";
import type { CSSProperties } from "react";

const stylesmap:any = {
  'cursor-pointer': 'cursor: pointer',

  'absolute': 'position: absolute',
  'relative': 'position: relative',
  'fixed': 'position: fixed',

  'hidden': 'display: none',
  'block': 'display: block',
  'inline': 'display: inline',
  'inline-block': 'display: inline-block',
  'flex': 'display: flex',
  'inline-flex': 'display: inline-flex',
  'grid': 'display: grid',
  'inline-grid': 'display: inline-grid',

  'text-center': 'textAlign: center',
  'text-left': 'textAlign: left',
  'text-right': 'textAlign: right',
  'text-justify': 'textAlign: justify',

  'align-top': 'verticalAlign: top',
  'align-middle': 'verticalAlign: middle',
  'align-bottom': 'verticalAlign: bottom',

  'text-xs': 'fontSize: 0.75rem',
  'text-sm': 'fontSize: 0.875rem',
  'text-md': 'fontSize: 0.9rem',
  'text-base': 'fontSize: 1rem',
  'text-ml': 'fontSize: 1.0675rem',
  'text-lg': 'fontSize: 1.125rem',
  'text-lg2': 'fontSize: 1.675rem',
  'text-xl': 'fontSize: 1.25rem',
  'text-xl2': 'fontSize: 1.325rem',
  'text-2xl': 'fontSize: 1.5rem',
  'text-2xl2': 'fontSize: 1.625rem',
  'text-3xl': 'fontSize: 1.875rem',

  'font-light': 'fontWeight: 300',
  'font-normal': 'fontWeight: 400',
  'font-medium': 'fontWeight: 500',
  'font-semibold': 'fontWeight: 600',
  'font-bold': 'fontWeight: 700',
  'font-extrabold': 'fontWeight: 800',

  'uppercase': 'textTransform: uppercase',
  'lowercase': 'textTransform: lowercase',
  'capitalize': 'textTransform: capitalize',

  'leading-minus-1': 'lineHeight: .85',
  'leading-minus-2': 'lineHeight: .75',
  'leading-minus-3': 'lineHeight: .65',
  'leading-none': 'lineHeight: 1',
  'leading-tight': 'lineHeight: 1.25',
  'leading-snug': 'lineHeight: 1.375',
  'leading-normal': 'lineHeight: 1.5',
  'leading-relaxed': 'lineHeight: 1.625',
  'leading-loose': 'lineHeight: 2',
  'leading-3': 'lineHeight: 0.75rem',
  'leading-4': 'lineHeight: 1rem',
  'leading-5': 'lineHeight: 1.25rem',
  'leading-6': 'lineHeight: 1.5rem',
  'leading-7': 'lineHeight: 1.75rem',
  'leading-8': 'lineHeight: 2rem',
  'leading-9': 'lineHeight: 2.25rem',
  'leading-10': 'lineHeight: 2.5rem',
  'leading-11': 'lineHeight: 2.75rem',
  'leading-12': 'lineHeight: 3rem',
  'leading-14': 'lineHeight: 3.5rem',
  'leading-16': 'lineHeight: 4rem',
  'leading-20': 'lineHeight: 5rem',

  'border': 'borderWidth: 1px',
  'border-2': 'borderWidth: 2px',
  'border-4': 'borderWidth: 4px',
  'border-8': 'borderWidth: 8px',

  'border-solid': 'borderStyle: solid',
  'border-dashed': 'borderStyle: dashed',
  'border-dotted': 'borderStyle: dotted',
  'border-none': 'borderStyle: none',

  'border-t-solid': 'borderTopStyle: solid',
  'border-t-dashed': 'borderTopStyle: dashed',
  'border-t-dotted': 'borderTopStyle: dotted',
  'border-t-none': 'borderTopStyle: none',

  'border-b-solid': 'borderBottomStyle: solid',
  'border-b-dashed': 'borderBottomStyle: dashed',
  'border-b-dotted': 'borderBottomStyle: dotted',
  'border-b-none': 'borderBottomStyle: none',

  'border-r-solid': 'borderRightStyle: solid',
  'border-r-dashed': 'borderRightStyle: dashed',
  'border-r-dotted': 'borderRightStyle: dotted',
  'border-r-none': 'borderRightStyle: none',

  'border-l-solid': 'borderLeftStyle: solid',
  'border-l-dashed': 'borderLeftStyle: dashed',
  'border-l-dotted': 'borderLeftStyle: dotted',
  'border-l-none': 'borderLeftStyle: none',

  'border-b': 'borderBottomWidth: 1px',
  'border-t': 'borderTopWidth: 1px',
  'border-l': 'borderLeftWidth: 1px',
  'border-r': 'borderRightWidth: 1px',
  'border-b-2': 'borderBottomWidth: 2px',
  'border-t-2': 'borderTopWidth: 2px',
  'border-l-2': 'borderLeftWidth: 2px',
  'border-r-2': 'borderRightWidth: 2px',
  'border-b-4': 'borderBottomWidth: 4px',
  'border-t-4': 'borderTopWidth: 4px',
  'border-l-4': 'borderLeftWidth: 4px',
  'border-r-4': 'borderRightWidth: 4px',

  'whitespace-normal': 'whiteSpace: normal',
  'whitespace-nowrap': 'whiteSpace: nowrap',
  'whitespace-pre': 'whiteSpace: pre',
  'whitespace-pre-wrap': 'whiteSpace: pre-wrap',

  'wrap-break-word': 'overflowWrap: break-word',
  'break-keep': 'wordBreak: keep-all',
  'break-word': 'wordBreak: break-word',

  'flex-row': 'flexDirection: row',
  'flex-row-reverse': 'flexDirection: row-reverse',
  'flex-wrap': 'flex-wrap: wrap',
  'flex-wrap-reverse': 'flex-wrap: wrap-reverse',
  'flex-col': 'flexDirection: column',
  'flex-col-reverse': 'flexDirection: column-reverse',

  'justify-start': 'justifyContent: flex-start',
  'justify-end': 'justifyContent: flex-end',
  'justify-center': 'justifyContent: center',
  'justify-between': 'justifyContent: space-between',
  'justify-around': 'justifyContent: around',
  'justify-evenly': 'justifyContent: evenly',
  'items-start': 'alignItems: flex-start',
  'items-end': 'alignItems: flex-end',
  'items-center': 'alignItems: center',
  'items-stretch': 'alignItems: stretch',
  'items-baseline': 'alignItems: baseline',

  'gap-0': 'gap: 0',
  'gap-1': 'gap: 0.25rem',
  'gap-2': 'gap: 0.5rem',
  'gap-3': 'gap: 0.75rem',
  'gap-4': 'gap: 1rem',
  'gap-5': 'gap: 1.25rem',
  'gap-6': 'gap: 1.5rem',
  'gap-12': 'gap: 3rem',
  'gap-x-0': 'columnGap: 0',
  'gap-x-1': 'columnGap: 0.25rem',
  'gap-x-2': 'columnGap: 0.5rem',
  'gap-x-3': 'columnGap: 0.75rem',
  'gap-x-4': 'columnGap: 1rem',
  'gap-x-5': 'columnGap: 1.25rem',
  'gap-x-6': 'columnGap: 1.5rem',
  'gap-x-12': 'columnGap: 3rem',
  'gap-y-0': 'rowGap: 0',
  'gap-y-1': 'rowGap: 0.25rem',
  'gap-y-2': 'rowGap: 0.5rem',
  'gap-y-3': 'rowGap: 0.75rem',
  'gap-y-4': 'rowGap: 1rem',
  'gap-y-5': 'rowGap: 1.25rem',
  'gap-y-6': 'rowGap: 1.5rem',
  
  'w-1/12': 'width: 8.333333%',
  'w-2/12': 'width: 16.666667%',
  'w-3/12': 'width: 25%',
  'w-4/12': 'width: 33.3333333%',
  'w-5/12': 'width: 41.666667%',
  'w-6/12': 'width: 50%',
  'w-7/12': 'width: 58.333333%',
  'w-8/12': 'width: 66.666667%',
  'w-9/12': 'width: 75%',
  'w-10/12': 'width: 83.333333%',
  'w-11/12': 'width: 91.666667%',
  'w-12/12': 'width: 100%',

  'w-1/24': 'width: 4.166667%',
  'w-2/24': 'width: 8.333333%',
  'w-3/24': 'width: 12.5%',
  'w-4/24': 'width: 16.666667%',
  'w-5/24': 'width: 20.833333%',
  'w-6/24': 'width: 25%',
  'w-7/24': 'width: 29.166667%',
  'w-8/24': 'width: 33.333333%',
  'w-9/24': 'width: 37.5%',
  'w-10/24': 'width: 41.666667%',
  'w-11/24': 'width: 45.833333%',
  'w-12/24': 'width: 50%',
  'w-13/24': 'width: 54.166667%',
  'w-14/24': 'width: 58.333333%',
  'w-15/24': 'width: 62.5%',
  'w-16/24': 'width: 66.666667%',
  'w-17/24': 'width: 70.833333%',
  'w-18/24': 'width: 75%',
  'w-19/24': 'width: 79.166667%',
  'w-20/24': 'width: 83.333333%',
  'w-21/24': 'width: 87.5%',
  'w-22/24': 'width: 91.666667%',
  'w-23/24': 'width: 95.833333%',
  'w-24/24': 'width: 100%',

  'min-w-[980px]': 'minWidth: 980px',
  'w-full': 'width: 100%',
  'w-screen': 'width: 100vw',

  'w-auto': 'width: auto',
  'w-0': 'width: 0px',
  'w-px': 'width: 1px',
  'w-0.5': 'width: 0.125rem',
  'w-1': 'width: 0.25rem',
  'w-1.5': 'width: 0.375rem',
  'w-2': 'width: 0.5rem',
  'w-2.5': 'width: 0.625rem',
  'w-3': 'width: 0.75rem',
  'w-3.5': 'width: 0.875rem',
  'w-4': 'width: 1rem',
  'w-5': 'width: 1.25rem',
  'w-6': 'width: 1.5rem',
  'w-7': 'width: 1.75rem',
  'w-8': 'width: 2rem',
  'w-9': 'width: 2.25rem',
  'w-10': 'width: 2.5rem',
  'w-11': 'width: 2.75rem',
  'w-12': 'width: 3rem',
  'w-14': 'width: 3.5rem',
  'w-16': 'width: 4rem',
  'w-20': 'width: 5rem',
  'w-24': 'width: 6rem',
  'w-28': 'width: 7rem',
  'w-32': 'width: 8rem',
  'w-36': 'width: 9rem',
  'w-40': 'width: 10rem',
  'w-44': 'width: 11rem',
  'w-48': 'width: 12rem',
  'w-52': 'width: 13rem',
  'w-56': 'width: 14rem',
  'w-60': 'width: 15rem',
  'w-64': 'width: 16rem',
  'w-72': 'width: 18rem',
  'w-80': 'width: 20rem',
  'w-96': 'width: 24rem',
  'w-100': 'width: 26rem',

  'h-0': 'height: 0px',
  'h-px': 'height: 1px',
  'h-0.5': 'height: 0.125rem',
  'h-1': 'height: 0.25rem',
  'h-1.5': 'height: 0.375rem',
  'h-2': 'height: 0.5rem',
  'h-2.5': 'height: 0.625rem',
  'h-3': 'height: 0.75rem',
  'h-3.5': 'height: 0.875rem',
  'h-4': 'height: 1rem',
  'h-5': 'height: 1.25rem',
  'h-6': 'height: 1.5rem',
  'h-7': 'height: 1.75rem',
  'h-8': 'height: 2rem',
  'h-9': 'height: 2.25rem',
  'h-10': 'height: 2.5rem',
  'h-11': 'height: 2.75rem',
  'h-12': 'height: 3rem',
  'h-14': 'height: 3.5rem',
  'h-16': 'height: 4rem',
  'h-20': 'height: 5rem',
  'h-24': 'height: 6rem',
  'h-28': 'height: 7rem',
  'h-32': 'height: 8rem',
  'h-36': 'height: 9rem',
  'h-40': 'height: 10rem',
  'h-44': 'height: 11rem',
  'h-48': 'height: 12rem',
  'h-52': 'height: 13rem',
  'h-56': 'height: 14rem',
  'h-60': 'height: 15rem',
  'h-64': 'height: 16rem',
  'h-72': 'height: 18rem',
  'h-80': 'height: 20rem',
  'h-96': 'height: 24rem',

  'top-0': 'top: 0px',
  'top-px': 'top: 1px',
  'top-0.5': 'top: 0.125rem',
  'top-1': 'top: 0.25rem',
  'top-1.5': 'top: 0.375rem',
  'top-2': 'top: 0.5rem',
  'top-2.5': 'top: 0.625rem',
  'top-3': 'top: 0.75rem',
  'top-3.5': 'top: 0.875rem',
  'top-4': 'top: 1rem',
  'top-5': 'top: 1.25rem',
  'top-6': 'top: 1.5rem',
  'top-7': 'top: 1.75rem',
  'top-8': 'top: 2rem',
  'top-9': 'top: 2.25rem',
  'top-10': 'top: 2.5rem',
  'top-11': 'top: 2.75rem',
  'top-12': 'top: 3rem',
  'top-14': 'top: 3.5rem',
  'top-16': 'top: 4rem',
  'top-20': 'top: 5rem',

  'right-0': 'right: 0px',
  'right-px': 'right: 1px',
  'right-0.5': 'right: 0.125rem',
  'right-1': 'right: 0.25rem',
  'right-1.5': 'right: 0.375rem',
  'right-2': 'right: 0.5rem',
  'right-2.5': 'right: 0.625rem',
  'right-3': 'right: 0.75rem',
  'right-3.5': 'right: 0.875rem',
  'right-4': 'right: 1rem',
  'right-5': 'right: 1.25rem',
  'right-6': 'right: 1.5rem',
  'right-7': 'right: 1.75rem',
  'right-8': 'right: 2rem',
  'right-9': 'right: 2.25rem',
  'right-10': 'right: 2.5rem',
  'right-11': 'right: 2.75rem',
  'right-12': 'right: 3rem',
  'right-14': 'right: 3.5rem',
  'right-16': 'right: 4rem',
  'right-20': 'right: 5rem',

  'bottom-0': 'bottom: 0px',
  'bottom-px': 'bottom: 1px',
  'bottom-0.5': 'bottom: 0.125rem',
  'bottom-1': 'bottom: 0.25rem',
  'bottom-1.5': 'bottom: 0.375rem',
  'bottom-2': 'bottom: 0.5rem',
  'bottom-2.5': 'bottom: 0.625rem',
  'bottom-3': 'bottom: 0.75rem',
  'bottom-3.5': 'bottom: 0.875rem',
  'bottom-4': 'bottom: 1rem',
  'bottom-5': 'bottom: 1.25rem',
  'bottom-6': 'bottom: 1.5rem',
  'bottom-7': 'bottom: 1.75rem',
  'bottom-8': 'bottom: 2rem',
  'bottom-9': 'bottom: 2.25rem',
  'bottom-10': 'bottom: 2.5rem',
  'bottom-11': 'bottom: 2.75rem',
  'bottom-12': 'bottom: 3rem',
  'bottom-14': 'bottom: 3.5rem',
  'bottom-16': 'bottom: 4rem',
  'bottom-20': 'bottom: 5rem',

  'left-0': 'left: 0px',
  'left-px': 'left: 1px',
  'left-0.5': 'left: 0.125rem',
  'left-1': 'left: 0.25rem',
  'left-1.5': 'left: 0.375rem',
  'left-2': 'left: 0.5rem',
  'left-2.5': 'left: 0.625rem',
  'left-3': 'left: 0.75rem',
  'left-3.5': 'left: 0.875rem',
  'left-4': 'left: 1rem',
  'left-5': 'left: 1.25rem',
  'left-6': 'left: 1.5rem',
  'left-7': 'left: 1.75rem',
  'left-8': 'left: 2rem',
  'left-9': 'left: 2.25rem',
  'left-10': 'left: 2.5rem',
  'left-11': 'left: 2.75rem',
  'left-12': 'left: 3rem',
  'left-14': 'left: 3.5rem',
  'left-16': 'left: 4rem',
  'left-20': 'left: 5rem',

  'm-0': 'margin: 0px',
  'm-0.5': 'margin: 2px',
  'm-1': 'margin: 4px',
  'm-1.5': 'margin: 6px',
  'm-2': 'margin: 8px',
  'm-2.5': 'margin: 10px',
  'm-3': 'margin: 12px',
  'm-3.5': 'margin: 14px',
  'm-4': 'margin: 16px',
  'm-4.5': 'margin: 18px',
  'm-5': 'margin: 20px',
  'm-5.5': 'margin: 22px',
  'm-6': 'margin: 24px',
  'm-6.5': 'margin: 26px',
  'm-7': 'margin: 28px',
  'm-7.5': 'margin: 30px',
  'm-8': 'margin: 32px',
  'm-8.5': 'margin: 34px',
  'm-9': 'margin: 36px',
  'm-9.5': 'margin: 38px',
  'm-10': 'margin: 40px',
  'm-11': 'margin: 44px',
  'm-12': 'margin: 48px',
  'm-13': 'margin: 52px',
  'm-14': 'margin: 56px',
  'm-15': 'margin: 60px',
  'm-auto': 'margin: auto',

  'mt-0': 'marginTop: 0px',
  'mt-0.5': 'marginTop: 2px',
  'mt-1': 'marginTop: 4px',
  'mt-1.5': 'marginTop: 6px',
  'mt-2': 'marginTop: 8px',
  'mt-2.5': 'marginTop: 10px',
  'mt-3': 'marginTop: 12px',
  'mt-3.5': 'marginTop: 14px',
  'mt-4': 'marginTop: 16px',
  'mt-4.5': 'marginTop: 18px',
  'mt-5': 'marginTop: 20px',
  'mt-5.5': 'marginTop: 22px',
  'mt-6': 'marginTop: 24px',
  'mt-6.5': 'marginTop: 26px',
  'mt-7': 'marginTop: 28px',
  'mt-7.5': 'marginTop: 30px',
  'mt-8': 'marginTop: 32px',
  'mt-8.5': 'marginTop: 34px',
  'mt-9': 'marginTop: 36px',
  'mt-9.5': 'marginTop: 38px',
  'mt-10': 'marginTop: 40px',
  'mt-11': 'marginTop: 44px',
  'mt-12': 'marginTop: 48px',
  'mt-13': 'marginTop: 52px',
  'mt-14': 'marginTop: 56px',
  'mt-15': 'marginTop: 60px',
  'mt-auto': 'marginTop: auto',
  'mt-[-1px]': 'marginTop: -1px',
  'mt-[-2px]': 'marginTop: -2px',
  'mt-[-3px]': 'marginTop: -3px',
  'mt-[-4px]': 'marginTop: -4px',
  'mt-[-5px]': 'marginTop: -5px',
  'mt-[-10px]': 'marginTop: -10px',
  'mt-[-20px]': 'marginTop: -20px',
  'mt-[-30px]': 'marginTop: -30px',
  'mt-[-50px]': 'marginTop: -50px',

  'mr-0': 'marginRight: 0px',
  'mr-0.5': 'marginRight: 2px',
  'mr-1': 'marginRight: 4px',
  'mr-1.5': 'marginRight: 6px',
  'mr-2': 'marginRight: 8px',
  'mr-2.5': 'marginRight: 10px',
  'mr-3': 'marginRight: 12px',
  'mr-3.5': 'marginRight: 14px',
  'mr-4': 'marginRight: 16px',
  'mr-4.5': 'marginRight: 18px',
  'mr-5': 'marginRight: 20px',
  'mr-5.5': 'marginRight: 22px',
  'mr-6': 'marginRight: 24px',
  'mr-6.5': 'marginRight: 26px',
  'mr-7': 'marginRight: 28px',
  'mr-7.5': 'marginRight: 30px',
  'mr-8': 'marginRight: 32px',
  'mr-8.5': 'marginRight: 34px',
  'mr-9': 'marginRight: 36px',
  'mr-9.5': 'marginRight: 38px',
  'mr-10': 'marginRight: 40px',
  'mr-11': 'marginRight: 44px',
  'mr-12': 'marginRight: 48px',
  'mr-13': 'marginRight: 52px',
  'mr-14': 'marginRight: 56px',
  'mr-15': 'marginRight: 60px',
  'mr-auto': 'marginRight: auto',
  'mr-[-1px]': 'marginRight: -1px',
  'mr-[-2px]': 'marginRight: -2px',
  'mr-[-3px]': 'marginRight: -3px',
  'mr-[-4px]': 'marginRight: -4px',
  'mr-[-5px]': 'marginRight: -5px',
  'mr-[-10px]': 'marginRight: -10px',
  'mr-[-20px]': 'marginRight: -20px',
  'mr-[-30px]': 'marginRight: -30px',
  'mr-[-50px]': 'marginRight: -50px',

  'mb-0': 'marginBottom: 0px',
  'mb-0.5': 'marginBottom: 2px',
  'mb-1': 'marginBottom: 4px',
  'mb-1.5': 'marginBottom: 6px',
  'mb-2': 'marginBottom: 8px',
  'mb-2.5': 'marginBottom: 10px',
  'mb-3': 'marginBottom: 12px',
  'mb-3.5': 'marginBottom: 14px',
  'mb-4': 'marginBottom: 16px',
  'mb-4.5': 'marginBottom: 18px',
  'mb-5': 'marginBottom: 20px',
  'mb-5.5': 'marginBottom: 22px',
  'mb-6': 'marginBottom: 24px',
  'mb-6.5': 'marginBottom: 26px',
  'mb-7': 'marginBottom: 28px',
  'mb-7.5': 'marginBottom: 30px',
  'mb-8': 'marginBottom: 32px',
  'mb-8.5': 'marginBottom: 34px',
  'mb-9': 'marginBottom: 36px',
  'mb-9.5': 'marginBottom: 38px',
  'mb-10': 'marginBottom: 40px',
  'mb-11': 'marginBottom: 44px',
  'mb-12': 'marginBottom: 48px',
  'mb-13': 'marginBottom: 52px',
  'mb-14': 'marginBottom: 56px',
  'mb-15': 'marginBottom: 60px',
  'mb-auto': 'marginBottom: auto',
  'mb-[-1px]': 'marginBottom: -1px',
  'mb-[-2px]': 'marginBottom: -2px',
  'mb-[-3px]': 'marginBottom: -3px',
  'mb-[-4px]': 'marginBottom: -4px',
  'mb-[-5px]': 'marginBottom: -5px',
  'mb-[-10px]': 'marginBottom: -10px',
  'mb-[-20px]': 'marginBottom: -20px',
  'mb-[-30px]': 'marginBottom: -30px',
  'mb-[-50px]': 'marginBottom: -50px',

  'ml-0': 'marginLeft: 0px',
  'ml-0.5': 'marginLeft: 2px',
  'ml-1': 'marginLeft: 4px',
  'ml-1.5': 'marginLeft: 6px',
  'ml-2': 'marginLeft: 8px',
  'ml-2.5': 'marginLeft: 10px',
  'ml-3': 'marginLeft: 12px',
  'ml-3.5': 'marginLeft: 14px',
  'ml-4': 'marginLeft: 16px',
  'ml-4.5': 'marginLeft: 18px',
  'ml-5': 'marginLeft: 20px',
  'ml-5.5': 'marginLeft: 22px',
  'ml-6': 'marginLeft: 24px',
  'ml-6.5': 'marginLeft: 26px',
  'ml-7': 'marginLeft: 28px',
  'ml-7.5': 'marginLeft: 30px',
  'ml-8': 'marginLeft: 32px',
  'ml-8.5': 'marginLeft: 34px',
  'ml-9': 'marginLeft: 36px',
  'ml-9.5': 'marginLeft: 38px',
  'ml-10': 'marginLeft: 40px',
  'ml-11': 'marginLeft: 44px',
  'ml-12': 'marginLeft: 48px',
  'ml-13': 'marginLeft: 52px',
  'ml-14': 'marginLeft: 56px',
  'ml-15': 'marginLeft: 60px',
  'ml-auto': 'marginLeft: auto',
  'ml-[-1px]': 'marginLeft: -1px',
  'ml-[-2px]': 'marginLeft: -2px',
  'ml-[-3px]': 'marginLeft: -3px',
  'ml-[-4px]': 'marginLeft: -4px',
  'ml-[-5px]': 'marginLeft: -5px',
  'ml-[-10px]': 'marginLeft: -10px',
  'ml-[-20px]': 'marginLeft: -20px',
  'ml-[-30px]': 'marginLeft: -30px',
  'ml-[-50px]': 'marginLeft: -50px',

  'p-0': 'padding: 0px',
  'p-0.5': 'padding: 2px',
  'p-1': 'padding: 4px',
  'p-1.5': 'padding: 6px',
  'p-2': 'padding: 8px',
  'p-2.5': 'padding: 10px',
  'p-3': 'padding: 12px',
  'p-3.5': 'padding: 14px',
  'p-4': 'padding: 16px',
  'p-4.5': 'padding: 18px',
  'p-5': 'padding: 20px',
  'p-5.5': 'padding: 22px',
  'p-6': 'padding: 24px',
  'p-6.5': 'padding: 26px',
  'p-7': 'padding: 28px',
  'p-7.5': 'padding: 30px',
  'p-8': 'padding: 32px',
  'p-8.5': 'padding: 34px',
  'p-9': 'padding: 36px',
  'p-9.5': 'padding: 38px',
  'p-10': 'padding: 40px',
  'p-11': 'padding: 44px',
  'p-12': 'padding: 48px',
  'p-13': 'padding: 52px',
  'p-14': 'padding: 56px',
  'p-15': 'padding: 60px',
  'p-auto': 'padding: auto',

  'pt-0': 'paddingTop: 0px',
  'pt-0.5': 'paddingTop: 2px',
  'pt-1': 'paddingTop: 4px',
  'pt-1.5': 'paddingTop: 6px',
  'pt-2': 'paddingTop: 8px',
  'pt-2.5': 'paddingTop: 10px',
  'pt-3': 'paddingTop: 12px',
  'pt-3.5': 'paddingTop: 14px',
  'pt-4': 'paddingTop: 16px',
  'pt-4.5': 'paddingTop: 18px',
  'pt-5': 'paddingTop: 20px',
  'pt-5.5': 'paddingTop: 22px',
  'pt-6': 'paddingTop: 24px',
  'pt-6.5': 'paddingTop: 26px',
  'pt-7': 'paddingTop: 28px',
  'pt-7.5': 'paddingTop: 30px',
  'pt-8': 'paddingTop: 32px',
  'pt-8.5': 'paddingTop: 34px',
  'pt-9': 'paddingTop: 36px',
  'pt-9.5': 'paddingTop: 38px',
  'pt-10': 'paddingTop: 40px',
  'pt-11': 'paddingTop: 44px',
  'pt-12': 'paddingTop: 48px',
  'pt-13': 'paddingTop: 52px',
  'pt-14': 'paddingTop: 56px',
  'pt-15': 'paddingTop: 60px',
  'pt-auto': 'paddingTop: auto',

  'pr-0': 'paddingRight: 0px',
  'pr-0.5': 'paddingRight: 2px',
  'pr-1': 'paddingRight: 4px',
  'pr-1.5': 'paddingRight: 6px',
  'pr-2': 'paddingRight: 8px',
  'pr-2.5': 'paddingRight: 10px',
  'pr-3': 'paddingRight: 12px',
  'pr-3.5': 'paddingRight: 14px',
  'pr-4': 'paddingRight: 16px',
  'pr-4.5': 'paddingRight: 18px',
  'pr-5': 'paddingRight: 20px',
  'pr-5.5': 'paddingRight: 22px',
  'pr-6': 'paddingRight: 24px',
  'pr-6.5': 'paddingRight: 26px',
  'pr-7': 'paddingRight: 28px',
  'pr-7.5': 'paddingRight: 30px',
  'pr-8': 'paddingRight: 32px',
  'pr-8.5': 'paddingRight: 34px',
  'pr-9': 'paddingRight: 36px',
  'pr-9.5': 'paddingRight: 38px',
  'pr-10': 'paddingRight: 40px',
  'pr-11': 'paddingRight: 44px',
  'pr-12': 'paddingRight: 48px',
  'pr-13': 'paddingRight: 52px',
  'pr-14': 'paddingRight: 56px',
  'pr-15': 'paddingRight: 60px',
  'pr-auto': 'paddingRight: auto',

  'pb-0': 'paddingBottom: 0px',
  'pb-0.5': 'paddingBottom: 2px',
  'pb-1': 'paddingBottom: 4px',
  'pb-1.5': 'paddingBottom: 6px',
  'pb-2': 'paddingBottom: 8px',
  'pb-2.5': 'paddingBottom: 10px',
  'pb-3': 'paddingBottom: 12px',
  'pb-3.5': 'paddingBottom: 14px',
  'pb-4': 'paddingBottom: 16px',
  'pb-4.5': 'paddingBottom: 18px',
  'pb-5': 'paddingBottom: 20px',
  'pb-5.5': 'paddingBottom: 22px',
  'pb-6': 'paddingBottom: 24px',
  'pb-6.5': 'paddingBottom: 26px',
  'pb-7': 'paddingBottom: 28px',
  'pb-7.5': 'paddingBottom: 30px',
  'pb-8': 'paddingBottom: 32px',
  'pb-8.5': 'paddingBottom: 34px',
  'pb-9': 'paddingBottom: 36px',
  'pb-9.5': 'paddingBottom: 38px',
  'pb-10': 'paddingBottom: 40px',
  'pb-11': 'paddingBottom: 44px',
  'pb-12': 'paddingBottom: 48px',
  'pb-13': 'paddingBottom: 52px',
  'pb-14': 'paddingBottom: 56px',
  'pb-15': 'paddingBottom: 60px',
  'pb-auto': 'paddingBottom: auto',

  'pl-0': 'paddingLeft: 0px',
  'pl-0.5': 'paddingLeft: 2px',
  'pl-1': 'paddingLeft: 4px',
  'pl-1.5': 'paddingLeft: 6px',
  'pl-2': 'paddingLeft: 8px',
  'pl-2.5': 'paddingLeft: 10px',
  'pl-3': 'paddingLeft: 12px',
  'pl-3.5': 'paddingLeft: 14px',
  'pl-4': 'paddingLeft: 16px',
  'pl-4.5': 'paddingLeft: 18px',
  'pl-5': 'paddingLeft: 20px',
  'pl-5.5': 'paddingLeft: 22px',
  'pl-6': 'paddingLeft: 24px',
  'pl-6.5': 'paddingLeft: 26px',
  'pl-7': 'paddingLeft: 28px',
  'pl-7.5': 'paddingLeft: 30px',
  'pl-8': 'paddingLeft: 32px',
  'pl-8.5': 'paddingLeft: 34px',
  'pl-9': 'paddingLeft: 36px',
  'pl-9.5': 'paddingLeft: 38px',
  'pl-10': 'paddingLeft: 40px',
  'pl-11': 'paddingLeft: 44px',
  'pl-12': 'paddingLeft: 48px',
  'pl-13': 'paddingLeft: 52px',
  'pl-14': 'paddingLeft: 56px',
  'pl-15': 'paddingLeft: 60px',
  'pl-auto': 'paddingLeft: auto',

  'table-auto': 'tableLayout: auto',
  'table-fixed': 'tableLayout: fixed',

  'grid-cols-0': 'gridTemplateColumns: repeat(0, minmax(0, 1fr))',
  'grid-cols-1': 'gridTemplateColumns: repeat(1, minmax(0, 1fr))',
  'grid-cols-2': 'gridTemplateColumns: repeat(2, minmax(0, 1fr))',
  'grid-cols-3': 'gridTemplateColumns: repeat(3, minmax(0, 1fr))',
  'grid-cols-4': 'gridTemplateColumns: repeat(4, minmax(0, 1fr))',
  'grid-cols-5': 'gridTemplateColumns: repeat(5, minmax(0, 1fr))',
  'grid-cols-6': 'gridTemplateColumns: repeat(6, minmax(0, 1fr))',
  'grid-cols-7': 'gridTemplateColumns: repeat(7, minmax(0, 1fr))',
  'grid-cols-8': 'gridTemplateColumns: repeat(8, minmax(0, 1fr))',
  'grid-cols-9': 'gridTemplateColumns: repeat(9, minmax(0, 1fr))',
  'grid-cols-10': 'gridTemplateColumns: repeat(10, minmax(0, 1fr))',
  'grid-cols-11': 'gridTemplateColumns: repeat(11, minmax(0, 1fr))',
  'grid-cols-12': 'gridTemplateColumns: repeat(12, minmax(0, 1fr))',
  'grid-cols-13': 'gridTemplateColumns: repeat(13, minmax(0, 1fr))',
  'grid-cols-14': 'gridTemplateColumns: repeat(14, minmax(0, 1fr))',
  'grid-cols-15': 'gridTemplateColumns: repeat(15, minmax(0, 1fr))',
  'grid-cols-16': 'gridTemplateColumns: repeat(16, minmax(0, 1fr))',
  'grid-cols-17': 'gridTemplateColumns: repeat(17, minmax(0, 1fr))',
  'grid-cols-18': 'gridTemplateColumns: repeat(18, minmax(0, 1fr))',
  'grid-cols-19': 'gridTemplateColumns: repeat(19, minmax(0, 1fr))',
  'grid-cols-20': 'gridTemplateColumns: repeat(20, minmax(0, 1fr))',
  'grid-cols-21': 'gridTemplateColumns: repeat(21, minmax(0, 1fr))',
  'grid-cols-22': 'gridTemplateColumns: repeat(22, minmax(0, 1fr))',
  'grid-cols-23': 'gridTemplateColumns: repeat(23, minmax(0, 1fr))',
  'grid-cols-24': 'gridTemplateColumns: repeat(24, minmax(0, 1fr))',

  'col-span-1': 'gridColumn: span 1 / span 1',
  'col-span-2': 'gridColumn: span 2 / span 2',
  'col-span-3': 'gridColumn: span 3 / span 3',
  'col-span-4': 'gridColumn: span 4 / span 4',
  'col-span-5': 'gridColumn: span 5 / span 5',
  'col-span-6': 'gridColumn: span 6 / span 6',
  'col-span-7': 'gridColumn: span 7 / span 7',
  'col-span-8': 'gridColumn: span 8 / span 8',
  'col-span-9': 'gridColumn: span 9 / span 9',
  'col-span-10': 'gridColumn: span 10 / span 10',
  'col-span-11': 'gridColumn: span 11 / span 11',
  'col-span-12': 'gridColumn: span 12 / span 12',
  'col-span-13': 'gridColumn: span 13 / span 13',
  'col-span-14': 'gridColumn: span 14 / span 14',
  'col-span-15': 'gridColumn: span 15 / span 15',
  'col-span-16': 'gridColumn: span 16 / span 16',
  'col-span-17': 'gridColumn: span 17 / span 17',
  'col-span-18': 'gridColumn: span 18 / span 18',
  'col-span-19': 'gridColumn: span 19 / span 19',
  'col-span-20': 'gridColumn: span 20 / span 20',
  'col-span-21': 'gridColumn: span 21 / span 21',
  'col-span-22': 'gridColumn: span 22 / span 22',
  'col-span-23': 'gridColumn: span 23 / span 23',
  'col-span-24': 'gridColumn: span 24 / span 24',
  'col-span-full': 'gridColumn: 1 / -1',

  'bg-gray-50': 'backgroundColor: #f9fafb',
  'bg-gray-100': 'backgroundColor: #f3f4f6',
  'bg-gray-200': 'backgroundColor: #e5e7eb',
  'bg-gray-300': 'backgroundColor: #d1d5db',
  'bg-gray-400': 'backgroundColor: #9ca3af',
  'bg-gray-500': 'backgroundColor: #6b7280',
  'bg-gray-600': 'backgroundColor: #4b5563',
  'bg-gray-700': 'backgroundColor: #374151',
  'bg-gray-800': 'backgroundColor: #1f2937',
  'bg-gray-900': 'backgroundColor: #111827',
  'bg-gray-950': 'backgroundColor: #030712',
  
  'bg-neutral-50': 'backgroundColor: #f5f5f5',
  'bg-neutral-100': 'backgroundColor: #e5e5e5',
  'bg-neutral-200': 'backgroundColor: #d4d4d4',
  'bg-neutral-300': 'backgroundColor: #a1a1aa',
  'bg-neutral-400': 'backgroundColor: #737373',
  'bg-neutral-500': 'backgroundColor: #525252',
  'bg-neutral-600': 'backgroundColor: #404040',
  'bg-neutral-700': 'backgroundColor: #262626',
  'bg-neutral-800': 'backgroundColor: #171717',
  'bg-neutral-900': 'backgroundColor: #111827',
  'bg-neutral-950': 'backgroundColor: #030712',

  'text-gray-50': 'color: #f9fafb',
  'text-gray-100': 'color: #f3f4f6',
  'text-gray-200': 'color: #e5e7eb',
  'text-gray-300': 'color: #d1d5db',
  'text-gray-400': 'color: #9ca3af',
  'text-gray-500': 'color: #6b7280',
  'text-gray-600': 'color: #4b5563',
  'text-gray-700': 'color: #374151',
  'text-gray-800': 'color: #1f2937',
  'text-gray-900': 'color: #111827',
  'text-gray-950': 'color: #030712',
  
  'text-neutral-50': 'color: #f5f5f5',
  'text-neutral-100': 'color: #e5e5e5',
  'text-neutral-200': 'color: #d4d4d4',
  'text-neutral-300': 'color: #a1a1aa',
  'text-neutral-400': 'color: #737373',
  'text-neutral-500': 'color: #525252',
  'text-neutral-600': 'color: #404040',
  'text-neutral-700': 'color: #262626',
  'text-neutral-800': 'color: #171717',
  'text-neutral-900': 'color: #111827',
  'text-neutral-950': 'color: #030712',

  'border-gray-50': 'borderColor: #f9fafb',
  'border-gray-100': 'borderColor: #f3f4f6',
  'border-gray-200': 'borderColor: #e5e7eb',
  'border-gray-300': 'borderColor: #d1d5db',
  'border-gray-400': 'borderColor: #9ca3af',
  'border-gray-500': 'borderColor: #6b7280',
  'border-gray-600': 'borderColor: #4b5563',
  'border-gray-700': 'borderColor: #374151',
  'border-gray-800': 'borderColor: #1f2937',
  'border-gray-900': 'borderColor: #111827',
  'border-gray-950': 'borderColor: #030712',
  
  'border-neutral-50': 'borderColor: #f5f5f5',
  'border-neutral-100': 'borderColor: #e5e5e5',
  'border-neutral-200': 'borderColor: #d4d4d4',
  'border-neutral-300': 'borderColor: #a1a1aa',
  'border-neutral-400': 'borderColor: #737373',
  'border-neutral-500': 'borderColor: #525252',
  'border-neutral-600': 'borderColor: #404040',
  'border-neutral-700': 'borderColor: #262626',
  'border-neutral-800': 'borderColor: #171717',
  'border-neutral-900': 'borderColor: #111827',
  'border-neutral-950': 'borderColor: #030712',

  'border-b-neutral-50': 'borderBottomColor: #f5f5f5',
  'border-b-neutral-100': 'borderBottomColor: #e5e5e5',
  'border-b-neutral-200': 'borderBottomColor: #d4d4d4',
  'border-b-neutral-300': 'borderBottomColor: #a1a1aa',
  'border-b-neutral-400': 'borderBottomColor: #737373',
  'border-b-neutral-500': 'borderBottomColor: #525252',
  'border-b-neutral-600': 'borderBottomColor: #404040',
  'border-b-neutral-700': 'borderBottomColor: #262626',
  'border-b-neutral-800': 'borderBottomColor: #171717',
  'border-b-neutral-900': 'borderBottomColor: #111827',
  'border-b-neutral-950': 'borderBottomColor: #030712',

  'border-t-neutral-50': 'borderTopColor: #f5f5f5',
  'border-t-neutral-100': 'borderTopColor: #e5e5e5',
  'border-t-neutral-200': 'borderTopColor: #d4d4d4',
  'border-t-neutral-300': 'borderTopColor: #a1a1aa',
  'border-t-neutral-400': 'borderTopColor: #737373',
  'border-t-neutral-500': 'borderTopColor: #525252',
  'border-t-neutral-600': 'borderTopColor: #404040',
  'border-t-neutral-700': 'borderTopColor: #262626',
  'border-t-neutral-800': 'borderTopColor: #171717',
  'border-t-neutral-900': 'borderTopColor: #111827',
  'border-t-neutral-950': 'borderTopColor: #030712',

  'text-white': 'color: #FFFFFF',
  'text-black': 'color: #000000',

  'rounded-sm': 'borderRadius: 2px',
  'rounded': 'borderRadius: 4px',
  'rounded-md': 'borderRadius: 6px',
  'rounded-lg': 'borderRadius: 8px',
  'rounded-full': 'borderRadius: 9999px',

  'bg-blue-300': 'backgroundColor: #93c5fd',
  'bg-green-300': 'backgroundColor: #86efac',
  'bg-red-300': 'backgroundColor: #fca5a1',
  'bg-white': 'backgroundColor: #FFFFFF',
  'bg-black': 'backgroundColor: #000000',

  'border-blue-500': 'borderColor: #3b82f6',

  'overflow-x-hidden': 'overflowX: hidden',
  'overflow-y-hidden': 'overflowY: hidden',
  'overflow-hidden': 'overflow: hidden',
  'overflow-auto': 'overflow: auto',
  'overflow-scroll': 'overflow: scroll',
  'overflow-x-auto': 'overflowX: auto',
  'overflow-y-auto': 'overflowY: auto',
  'overflow-x-scroll': 'overflowX: scroll',
  'overflow-y-scroll': 'overflowY: scroll',
  'overflow-x-visible': 'overflowX: visible',
  'overflow-y-visible': 'overflowY: visible',
  'overflow-visible': 'overflow: visible',

  'w-[920px]': 'width: 920px',
  'w-[980px]': 'width: 980px',
  'w-[980pxpx]': 'width: 980px',
  'w-[1020px]': 'width: 1020px',
  'w-[1120px]': 'width: 1120px',
  'w-[1180px]': 'width: 1180px',
  'w-[1200px]': 'width: 1200px',
  'w-[1260px]': 'width: 1260px',
  'w-[1300px]': 'width: 1300px',

  'max-w-[980px]': 'maxWidth: 980px',
  'max-w-[1020px]': 'maxWidth: 1020px',
  'max-w-[1120px]': 'maxWidth: 1120px',
  'max-w-[1180px]': 'maxWidth: 1180px',
}

const classesToIgnore = ["mm-statement", "mm-section", "mm-section-header", "mm-design-defleppard"];

export const renderStyle = (
  classnameStr: string,
  format: "tw" | "styleObj" = "styleObj"
) => {
  if (!classnameStr) return null;

    if (format === "tw") {
      return { className: classnameStr };
    }

    const style: Record<string, string> = {};

    classnameStr.split(" ").forEach((classname: string) => {
      if (classesToIgnore.includes(classname)) return;
      const raw = stylesmap[classname];
      
      if (!raw) {
        console.error(`❌ Style not found for: ${classname}`);
        return;
      }

      const [prop, val] = raw.split(":");
      (style as any)[prop.trim()] = val.trim();
    });

    return { style };
}


export const useRenderStyling = (
  classnameStr: string,
  format: "tw" | "styleObj" = "styleObj"
) : { 
  className?: string; 
  style?: CSSProperties } | null => useMemo( () => {
    return renderStyle(classnameStr, format)
  }, [classnameStr, format]);



export const useRenderStylingOld = (
  classnameStr: string,
  format: "tw" | "styleObj" = "styleObj"
): { className?: string; style?: Record<string, string> } | null => {
  return useMemo(() => {
    if (!classnameStr) return null;

    if (format === "tw") {
      return { className: classnameStr };
    }

    const style: Record<string, string> = {};

    classnameStr.split(" ").forEach((classname: string) => {
      if (classesToIgnore.includes(classname)) return;

      console.log("generating style obj")
      const raw = stylesmap[classname];
      if (!raw) {
        console.error(`❌ Style not found for: ${classname}`);
        return;
      }

      const [prop, val] = raw.split(":");
      (style as any)[prop.trim()] = val.trim();
    });

    return { style };
  }, [classnameStr, format]);
};
